import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getRoutes = async () => {
    try {
        const response = await axios.get(`${API}/routes`);
        return response.data;
    } catch (error) {
        console.error("Error fetching routes:", error);
        return [];
    }
};

export const updateRoutePrice = async (id, price) => {
    try {
        const response = await axios.put(`${API}/routes/${id}`, { price: parseInt(price) });
        return response.data;
    } catch (error) {
        console.error("Error updating route:", error);
        throw error;
    }
};

export const deleteRoute = async (id) => {
    try {
        await axios.delete(`${API}/routes/${id}`);
        return true;
    } catch (error) {
        console.error("Error deleting route:", error);
        throw error;
    }
};

export const createRoute = async (routeData) => {
    try {
        const response = await axios.post(`${API}/routes`, routeData);
        return response.data;
    } catch (error) {
        console.error("Error creating route:", error);
        throw error;
    }
};
export const loginAdmin = async (password) => {
    try {
        const response = await axios.post(`${API}/admin/login`, { password });
        return response.data;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};
